var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_6063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7799 5.64355H45.8633V11.6536H53.7799L51.2266 8.45022L53.7799 5.64355Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8635 3.50977H39.8535V9.51977H45.8635V3.50977Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4979 33.5166V42.7133H6.14453L12.2079 33.5166H31.4979Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 39.3796L14.0007 36.8496H31.4973V39.3796H12.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7008 42.7133H48.3574V33.5166H67.6408L73.7008 42.7133Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3574 39.3796V36.8496H65.8441L67.5108 39.3796H48.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9744 3.50977H38.7344V16.1531H40.9744V3.50977Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1075 12.7734H44.7441V4.52344H56.3141L52.6975 8.5001L56.1075 12.7734ZM46.9808 10.5334H51.4541L49.7541 8.40677L51.2475 6.76344H46.9808V10.5334Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9844 10.6396H38.7344V2.38965H46.9844V10.6396ZM40.9744 8.39965H44.7444V4.62965H40.9744V8.39965Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4341 27.3829H44.8574L39.9307 22.4495L35.0074 27.3829H27.4141L39.9307 14.8662L45.1841 20.1262L50.2207 25.1695L52.4341 27.3829Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1376 28.5036H44.3909L39.9309 24.0369L35.4709 28.5036H24.7109L39.9343 13.2803L55.1409 28.5036H55.1376ZM45.3209 26.2636H49.7309L39.9309 16.4503L30.1176 26.2636H34.5409L39.9309 20.8669L45.3209 26.2636Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6482 42.7168V74.1268H51.4315C51.0982 72.7935 49.8882 71.8001 48.4482 71.8001H31.3815C29.9482 71.8001 28.7415 72.7935 28.4082 74.1268H12.2148V42.7168H67.6482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.358 27.3865V42.7131H31.498V27.3865H35.0047L39.9314 22.4531L44.858 27.3865H48.358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3902 70.7937C52.2035 69.357 50.4102 68.467 48.4469 68.467H31.3802C29.4169 68.467 27.6302 69.3537 26.4435 70.7937H15.5469V46.0537H64.3135V70.7937H53.3902Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7671 75.2467H50.5571L50.3438 74.3967C50.1271 73.5267 49.3471 72.92 48.4471 72.92H31.3804C30.4871 72.92 29.7104 73.5267 29.4937 74.3967L29.2838 75.2467H11.0938V41.5967H68.7671V75.2467ZM52.2038 73.0067H66.5271V43.84H13.3338V73.0067H27.6304C28.3271 71.6033 29.7638 70.68 31.3804 70.68H48.4471C50.0671 70.68 51.5071 71.6033 52.2038 73.0067Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6164 43.8331H4.06641L11.6031 32.3965H32.6164V43.8331ZM8.22307 41.5931H30.3764V34.6365H12.8097L8.22641 41.5931H8.22307Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4775 43.8329H30.3809V26.2662H34.5442L39.9342 20.8662L45.3242 26.2662H49.4775V43.8329ZM32.6175 41.5929H47.2375V28.5062H44.3942L39.9309 24.0362L35.4675 28.5062H32.6175V41.5929Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7797 43.8331H47.2363V32.3965H68.243L75.7797 43.8331ZM49.4763 41.5931H71.623L67.0397 34.6365H49.4797V41.5931H49.4763Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3067 59.9629H18.8301V66.4396H25.3067V59.9629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0235 59.9629H54.5469V66.4396H61.0235V59.9629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4276 67.5565H17.7109V58.8398H26.4276V67.5565ZM19.9509 65.3165H24.1876V61.0798H19.9509V65.3165Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1444 67.5565H53.4277V58.8398H62.1444V67.5565ZM55.6677 65.3165H59.9044V61.0798H55.6677V65.3165Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0667 48.1338C20.2801 48.1338 18.8301 49.5838 18.8301 51.3705V55.4738H25.3067V51.3705C25.3067 49.5838 23.8567 48.1338 22.0701 48.1338H22.0667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.973 48.1338C32.1863 48.1338 30.7363 49.5838 30.7363 51.3705V55.4738H37.213V51.3705C37.213 49.5838 35.763 48.1338 33.9763 48.1338H33.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8812 48.1338C44.0945 48.1338 42.6445 49.5838 42.6445 51.3705V55.4738H49.1212V51.3705C49.1212 49.5838 47.6712 48.1338 45.8845 48.1338H45.8812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7869 48.1338C59.5735 48.1338 61.0235 49.5838 61.0235 51.3705V55.4738H54.5469V51.3705C54.5469 49.5838 55.9969 48.1338 57.7835 48.1338H57.7869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4276 56.5937H17.7109V51.3703C17.7109 48.967 19.6643 47.0137 22.0676 47.0137C24.4709 47.0137 26.4243 48.9703 26.4243 51.3703V56.5937H26.4276ZM19.9509 54.3537H24.1876V51.3703C24.1876 50.2037 23.2376 49.2537 22.0676 49.2537C20.8976 49.2537 19.9509 50.2037 19.9509 51.3703V54.3537Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3305 56.5937H29.6172V51.3703C29.6172 48.967 31.5705 47.0137 33.9739 47.0137C36.3772 47.0137 38.3305 48.9703 38.3305 51.3703V56.5937ZM31.8572 54.3537H36.0939V51.3703C36.0939 50.2037 35.1439 49.2537 33.9772 49.2537C32.8105 49.2537 31.8605 50.2037 31.8605 51.3703V54.3537H31.8572Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2381 56.5937H41.5215V51.3703C41.5215 48.967 43.4748 47.0137 45.8782 47.0137C48.2815 47.0137 50.2348 48.9703 50.2348 51.3703V56.5937H50.2381ZM43.7615 54.3537H47.9982V51.3703C47.9982 50.2037 47.0482 49.2537 45.8815 49.2537C44.7148 49.2537 43.7648 50.2037 43.7648 51.3703V54.3537H43.7615Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1444 56.5937H53.4277V51.3703C53.4277 48.967 55.3811 47.0137 57.7844 47.0137C60.1877 47.0137 62.1411 48.9703 62.1411 51.3703V56.5937H62.1444ZM55.6677 54.3537H59.9044V51.3703C59.9044 50.2037 58.9544 49.2537 57.7877 49.2537C56.6211 49.2537 55.6677 50.2037 55.6677 51.3703V54.3537Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5211 74.8669V76.4502H28.3145V74.8669C28.3145 74.6069 28.3478 74.3669 28.4045 74.1235C28.7378 72.7902 29.9478 71.7969 31.3778 71.7969H48.4445C49.8845 71.7969 51.0945 72.7902 51.4278 74.1235C51.4845 74.3635 51.5178 74.6069 51.5178 74.8669H51.5211Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.64 77.5697H27.1934V74.8664C27.1934 74.533 27.2334 74.203 27.3167 73.8597C27.7867 71.983 29.4567 70.6797 31.38 70.6797H48.4467C50.3767 70.6797 52.05 71.983 52.5167 73.853C52.6 74.2064 52.64 74.5364 52.64 74.8664V77.5697ZM29.4334 75.3297H50.4034V74.8664C50.4034 74.7097 50.3834 74.5564 50.3434 74.3864C50.13 73.5297 49.35 72.9197 48.45 72.9197H31.3834C30.49 72.9197 29.7134 73.5264 29.4967 74.3964C29.4567 74.5597 29.4367 74.7097 29.4367 74.8664V75.3297H29.4334Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9244 59.96H30.7344V71.8H39.9244V59.96Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7344 59.96H39.9277V71.8L30.7344 59.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1177 59.96H39.9277V71.8H49.1177V59.96Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9277 59.96H49.1177V71.8L39.9277 59.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0472 72.9202H29.6172V58.8369H41.0472V72.9202ZM31.8539 70.6802H38.8072V61.0803H31.8539V70.6802Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2366 72.9202H38.8066V58.8369H50.2366V72.9202ZM41.0466 70.6802H47.9966V61.0803H41.0466V70.6802Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3444 66.7064C43.882 66.7064 44.3178 66.2707 44.3178 65.7331C44.3178 65.1955 43.882 64.7598 43.3444 64.7598C42.8069 64.7598 42.3711 65.1955 42.3711 65.7331C42.3711 66.2707 42.8069 66.7064 43.3444 66.7064Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6445 53.1064H71.3179C72.6312 53.1064 73.7012 54.1731 73.7012 55.4898V74.1264H67.6445V53.1098V53.1064Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52786 53.1069H12.2012V74.1235H6.14453V55.4869C6.14453 54.1735 7.2112 53.1035 8.52786 53.1035V53.1069Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8201 75.243H66.5234V51.9863H71.3168C73.2468 51.9863 74.8201 53.5563 74.8201 55.4897V75.2463V75.243ZM68.7634 73.003H72.5801V55.4897C72.5801 54.793 72.0134 54.2263 71.3168 54.2263H68.7634V73.003Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3207 75.2434H5.02734V55.4867C5.02734 53.5567 6.59734 51.9834 8.53068 51.9834H13.324V75.2401L13.3207 75.2434ZM7.26401 73.0034H11.0807V54.2267H8.52734C7.83068 54.2267 7.26401 54.7934 7.26401 55.4901V73.0034Z",
    fill: "#2A8DCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9282 38.7938C42.3619 38.7938 44.3348 36.8209 44.3348 34.3871C44.3348 31.9534 42.3619 29.9805 39.9282 29.9805C37.4944 29.9805 35.5215 31.9534 35.5215 34.3871C35.5215 36.8209 37.4944 38.7938 39.9282 38.7938Z",
    fill: "#C1E4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0948 31.327L36.8382 37.527C36.0215 36.727 35.5215 35.6103 35.5215 34.3836C35.5215 31.9503 37.4982 29.9736 39.9315 29.9736C41.1715 29.9736 42.2981 30.4903 43.0981 31.3236L43.0948 31.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9271 39.9137C36.8804 39.9137 34.4004 37.4337 34.4004 34.387C34.4004 31.3404 36.8804 28.8604 39.9271 28.8604C42.9737 28.8604 45.4537 31.3404 45.4537 34.387C45.4537 37.4337 42.9737 39.9137 39.9271 39.9137ZM39.9271 31.097C38.1137 31.097 36.6404 32.5704 36.6404 34.3837C36.6404 36.197 38.1137 37.6704 39.9271 37.6704C41.7404 37.6704 43.2171 36.197 43.2171 34.3837C43.2171 32.5704 41.7404 31.097 39.9271 31.097Z",
    fill: "#2A8DCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_6063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolsIcon);
export default __webpack_public_path__ + "static/media/schools-icon.f5174a9d540b787d217b9d41ca907614.svg";
export { ForwardRef as ReactComponent };